import React from "react";
import { Pressable, StyleProp, StyleSheet, ViewStyle } from "react-native";

import { isNative } from "@stepapp/core";
import { palette, spacing } from "../styles";
import Block from "./Block";
import Typography from "./Typography";

type Props = {
  placeholder?: string;
  value?: string;
  required?: boolean;
  error?: string;
  onPress: () => void;
  testID?: string;
  style?: StyleProp<ViewStyle>;
};

const TouchableInput = ({
  placeholder = "",
  value,
  required = false,
  error,
  onPress,
  testID,
  style,
}: Props) => {
  const showTopLabel = isNative && value && placeholder;

  return (
    <Pressable onPress={onPress} testID={testID} style={style}>
      {showTopLabel && (
        <Block style={styles.containerTopLabel}>
          <Typography type="secondary" style={styles.topLabel}>
            {placeholder}
            {required && <Typography type="lightError">*</Typography>}
          </Typography>
        </Block>
      )}

      <Block style={[styles.container, !!error && styles.containerError]}>
        <Typography
          type={value ? "primary" : "secondary"}
          variant={value ? "input" : "paragraph"}
          style={styles.textValue}
        >
          {value ? value : placeholder}
          {required && !value && <Typography type="lightError">*</Typography>}
        </Typography>
      </Block>

      <Block marginLeft={2} style={styles.error}>
        {error && (
          <Typography id="form-has-error" type="error" variant="lightLabel">
            {typeof error === "string" && error}
          </Typography>
        )}
      </Block>
    </Pressable>
  );
};

export default React.memo(TouchableInput);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: spacing.unit * 2,
    borderRadius: spacing.radius,
    borderWidth: spacing.border,
    borderColor: palette.common.mediumGray,
    paddingVertical: spacing.unit * 2,
  },
  containerError: {
    borderColor: palette.font.error,
  },
  containerTopLabel: {
    flex: 1,
    left: 14,
    top: -10,
    position: "absolute",
    zIndex: 10,
    backgroundColor: palette.common.white,
  },
  error: {
    height: spacing.unit * 2.5,
  },
  textValue: {
    alignContent: "center",
    top: 2,
  },
  topLabel: {
    borderRadius: 4,
    marginLeft: 2,
    overflow: "hidden",
    paddingHorizontal: 2,
    fontSize: 12,
  },
});
